import { useQuery } from "@tanstack/react-query";
import $api from "@/zapi-frontend/shared/api/axios";
import { z } from "zod";

const ExportHistoryItemSchema = z.object({
  id: z.number(),
  fileType: z.enum(["pdf", "docx", "md", "pptx", "presentation_pdf"]),
  fileUrl: z.string(),
  fileName: z.string(),
  fileSize: z.number().nullable(),
  createdAt: z.string(),
  user: z.object({
    id: z.number(),
    firstName: z.string(),
    lastName: z.string()
  })
});

const ExportHistoryResponseSchema = z.object({
  exports: z.array(ExportHistoryItemSchema),
  total: z.number()
});

export type TExportHistoryItem = z.infer<typeof ExportHistoryItemSchema>;

export function useExportHistory(projectId: string | null, limit = 3) {
  return useQuery({
    queryKey: ["exportHistory", projectId, limit],
    queryFn: async () => {
      if (!projectId) return null;

      const response = await $api.get<{ data: z.infer<typeof ExportHistoryResponseSchema> }>(
        `/projects/${projectId}/export/history`,
        {
          params: { limit, offset: 0 }
        }
      );

      return ExportHistoryResponseSchema.parse(response.data.data);
    },
    enabled: !!projectId,
    staleTime: 30000
  });
}
